import Circle from './../components/Circle';
import selectColor from './../helpers/selectColor';

const drawScaleScoreDots = (x, y, onePartSize, rotation, ir, mr, rings, scaleScores, colors) => {
    const circles = [];
    let selector = 0;
    for (let angle = 0; angle < Math.PI * 2; angle += onePartSize) {
        const ringWidth = ir + (mr / rings);
        const a = angle + rotation + (onePartSize / 2);
        // divide the positioning of the dot by 1.5
        // so it appears in the middle of the ring
        const r = (ringWidth * (scaleScores[selector]) / 1.5);
        circles.push(
            Circle.create()
                .fillColor(selectColor(colors, scaleScores[selector]))
                .strokeColor(colors.white)
                .strokeThickness('2px')
                .size(x + Math.sin(a) * r, y + Math.cos(a) * r, 7)
                .element()
        );
        selector++;
    }

    return circles;
};

export default drawScaleScoreDots;
